import {OebbDialogModal} from '@oebb-web-team/oebb-web-library/dist/dialog-modal/OebbDialogModal';

export class DialogHelper {

	static readonly instance = new DialogHelper();

	private readonly dialogs = new Map<string, OebbDialogModal>();

	getDialog(src: string, title?: string, triggerElement?: HTMLElement): OebbDialogModal {
		if (!this.dialogs.has(src)) {
			this.dialogs.set(src, this.createDialog(src, title, triggerElement));
		}
		return this.dialogs.get(src);
	}

	private createDialog(src: string, title?: string, triggerElement?: HTMLElement): OebbDialogModal {
		const style = `width: 100%; height: calc(100vh - 120px); display: block`;
		const htmlId = 'oebb-dialog-modal-' + Math.random().toString(36).substring(2, 6);

		const headerHtml = title
			? `<h2 id="${htmlId}">${title}</h2>`
			: ''

		// set focus on the element that previously opened dialog
		const hideCallback = triggerElement ? () => { triggerElement.focus(); } : null;

		return new OebbDialogModal({
			contentAsHtml: `<iframe title=${title ? title : null} src="${src}" width="800" height="600" style="${style}"></iframe>`,
			headerAsHtml: headerHtml,
			ariaLabelledBy: htmlId,
			hideCallback: hideCallback
		});
	}
}
